<template>
  <div>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">

      <!-- 清单列表 strat -->
      <el-tab-pane label="该活动的推广员列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入推广员名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.phone" @keyup.enter.native="clicksearch" placeholder="请输入手机号码" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <el-button type="info" @click="clickreturnshang">返回</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Name" label="推广员名称" min-width="5%"></el-table-column>
          <el-table-column prop="Phone" label="手机号码" min-width="5%"></el-table-column>
          <el-table-column prop="Qrcodestatusname" label="推广码状态" min-width="5%"></el-table-column>
          <el-table-column prop="Qrcodeurl" label="推广码" min-width="5%">
            <template slot-scope="scope">
              <img :src="scope.row.Qrcodeurl" min-width="64" height="64" />
            </template>
          </el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="10%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="8%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickedit(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickqrcode(scope.row)">下载推广码</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>

      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="添加推广员" name="second">
      <el-form :model="addForm" ref="addFormRef" label-width="170px">
        <el-form-item label="推广员名称" class="addAdminForm">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" class="addAdminForm">
          <el-input v-model="addForm.phone"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickadd">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

    <!-- 修改 start -->
    <el-tab-pane label="修改推广员" name="three" disabled="disabled">
      <el-form :model="editForm" ref="editFormRef" label-width="170px">
        <el-form-item label="推广员名称" class="addAdminForm">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" class="addAdminForm">
          <el-input v-model="editForm.phone"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksave">保存</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 修改 end -->

    <!-- 下载推广码 start -->
    <el-tab-pane label="下载推广码" name="four" disabled="disabled">
      <el-form :model="editForm" ref="editFormRef" label-width="170px">
        <el-form-item>
          <el-button type="primary" @click="clickdownload">下载</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
      <div class="case" ref="box">
        <img class="caseimg0" src="../assets/images/mubanditui.png">
        <img class="caseimg1" src="" id="caseimg1">
<!--        <div class="caseword">
          <p class="casename1">活动：</p>
          <p class="casename2">{{activityname}}</p>
          <p class="caseage1">推广员：</p>
          <p class="caseage2">{{promotersname}}</p>
        </div> -->
      </div>
    </el-tab-pane>
    <!-- 下载推广码 end -->

  </el-tabs>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  name: 'MyMiniAppRuiDiTuiActivityModify',
  data () {
    return {
      activeName: 'first',
      addForm: {
        name: '',
        phone: ''
      },
      editForm: {
        id: 0,
        name: '',
        phone: ''
      },
      // 查询
      keywords: {
        name: '',
        phone: ''
      },
      dataList: [],
      dataListnum: 0,
      activityid: 0,
      selectedPageNo: 1,
      activityname: '',
      promotersname: '',
      qrcodeurl: ''
    }
  },
  mounted () {
  },
  methods: {
    LoadData (row) {
      this.activityid = row.Id
      this.activityname = row.Name
      this.apiGetMiniAppRuiDiTuiPromotersNum()
      this.apiGetMiniAppRuiDiTuiPromotersList()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetMiniAppRuiDiTuiPromotersNum()
      this.apiGetMiniAppRuiDiTuiPromotersList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetMiniAppRuiDiTuiPromotersList()
    },
    clickadd () {
      this.apiAddMiniAppRuiDiTuiPromoters()
    },
    clickreturnshang () {
      this.$emit('triggerFunc', '')
    },
    clickreturn () {
      this.activeName = 'first'
      this.qrcodeurl = ''
      this.promotersname = ''
    },
    clickedit (row) {
      this.activeName = 'three'
      this.editForm.id = row.Id
      this.editForm.name = row.Name
      this.editForm.phone = row.Phone
    },
    clickqrcode (row) {
      this.activeName = 'four'
      this.qrcodeurl = row.Qrcodeurl
      this.promotersname = row.Name
      this.getImage(this.qrcodeurl, 'caseimg1')
    },
    getImage: function (url, imgId) {
      document.getElementById(imgId).src = ''

      var xhr = new XMLHttpRequest()
      xhr.open('get', url, true)
      xhr.responseType = 'blob'
      xhr.onload = function () {
        if (this.status === 200) {
          document.getElementById(imgId).src = URL.createObjectURL(this.response)
        }
      }
      xhr.send()
    },
    clicksave () {
      this.apiEditMiniAppRuiDiTuiPromoters()
    },
    clickdownload () {
      var that = this
      html2canvas(that.$refs.box, {
        useCORS: true,
        allowTaint: false
      }).then(function (canvas) {
        var a = document.createElement('a')
        a.href = canvas.toDataURL('image/jpeg')
        a.download = that.promotersname + '.jpg'
        a.click()
        a.remove()
      })
    },
    apiGetMiniAppRuiDiTuiPromotersList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        activityid: that.activityid,
        pageno: that.selectedPageNo,
        name: that.keywords.name,
        phone: that.keywords.phone
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetMiniAppRuiDiTuiPromotersList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetMiniAppRuiDiTuiPromotersNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        activityid: that.activityid,
        name: that.keywords.name,
        phone: that.keywords.phone
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetMiniAppRuiDiTuiPromotersNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddMiniAppRuiDiTuiPromoters: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        activityid: that.activityid,
        name: that.addForm.name,
        phone: that.addForm.phone
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddMiniAppRuiDiTuiPromoters, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetMiniAppRuiDiTuiPromotersList()
            that.apiGetMiniAppRuiDiTuiPromotersNum()

            // 清空添加
            that.addForm.name = ''
            that.addForm.phone = ''
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditMiniAppRuiDiTuiPromoters: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editForm.id,
        name: that.editForm.name,
        phone: that.editForm.phone
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditMiniAppRuiDiTuiPromoters, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetMiniAppRuiDiTuiPromotersList()
            that.apiGetMiniAppRuiDiTuiPromotersNum()

            // 清空添加
            that.editForm.id = 0
            that.editForm.name = ''
            that.editForm.phone = ''
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}
.select1{
    width: 113px;
    margin-right: 15px;
}
/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
/deep/ .el-table .cell {
  white-space: pre-line;
}

.case{
    width: 645px;
    height: 900px;
    position: relative;
}

.caseimg0{
  width: 645px;
  height: 900px;
  position: absolute;
  z-index: 5;
}

.caseimg1{
  width: 430px;
  height: 430px;
  position: absolute;
  z-index: 10;
  left: 107px;
  top: 65px;
}

.caseword{
  color:#000000;
  font-size: 30px;
}
.casename1{
  position: absolute;
  z-index: 30;
  left: 10px;
  top: 430px;
}
.casename2{
  position: absolute;
  z-index: 30;
  left: 150px;
  top: 430px;
}
.caseage1{
  position: absolute;
  z-index: 30;
  left: 10px;
  top: 470px;
}
.caseage2{
  position: absolute;
  z-index: 30;
  left: 150px;
  top: 470px;
}
</style>
